import * as React from 'react'
import { ParentSize } from '@vx/responsive'
import InfoCard from 'components/Cards/InfoCard'
import { flow, groupBy, map, mapValues, countBy, identity, sum, values } from 'lodash/fp'
import { moment } from 'features/Moment'
import { unitOfTime } from 'moment'
import { unionBy, orderBy } from 'lodash'
import { GraphStackedBar } from '../../GraphStackedBar'
import { mapWithKey } from '../../../../utils/lodash'
import { ICall } from 'features/CallAnalytics/types'

const formatData = (data: ICall[], sumPeriod: unitOfTime.StartOf): any =>
  flow(
    map((call: ICall) => ({
      ...call,
      dateTime: moment(call.dateTime)
        .local()
        .startOf(sumPeriod)
        .format(),
    })),
    groupBy('dateTime'),
    mapWithKey(items => ({
      date: items[0].dateTime,
      ...flow<any, any, any, any>(map('callStatus'), countBy(identity), items => {
        const total = sum(values(items))
        return mapValues(item => (item / total) * 100, items)
      })(items),
    }))
  )(data)

export const CallsByStatus = ({ calls, dateInterval, sumPeriod, dateFormat, loading }) => {
  const data = formatData(calls, sumPeriod)
  const baseData = dateInterval.map(date => ({ date }))
  const allData = orderBy(unionBy(data, baseData, 'date'), 'date')

  return (
    <InfoCard style={{ height: '100%' }} title="Calls by status" loading={loading} allowOverflow>
      <ParentSize>
        {({ width }) => (
          <GraphStackedBar width={width} height={400} data={allData} dateFormat={dateFormat} />
        )}
      </ParentSize>
    </InfoCard>
  )
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsByStatus/CallsByStatus.tsx